export interface HttpError extends Error {
    status: number;
}

export function isHttpError(error: unknown): error is HttpError {
    return error instanceof Error && typeof (error as { status?: unknown }).status === 'number';
}

export function httpError(message: string, status: number): HttpError {
    return Object.assign(new Error(message), { status });
}
